<div
    style="height: calc(90vh - 200px);"
>
<order-detail-documents
    style="display: block; height: 100%;"
    [documents]="documents"
    [editing]="editing"
    [uploadFunction]="this.uploadFunction.bind(this)"
    (documentDeleted)="onDocumentDeleted($event)"
    (tagsEdited)="onTagsEdited($event)"
>    
</order-detail-documents>
</div>
